import { useAtom } from "jotai";
import { atom } from "jotai";
import { DateTime } from "luxon";
import { useEffect, useRef } from "react";

export const statFiltersAtom = atom({
  beginAt: "",
  endAt: "",
});
export const selectedShortcutAtom = atom("3");

const useStatFilters = (refreshWithFilters = () => {}) => {
  const [statFilters, setStatFilters] = useAtom(statFiltersAtom);
  const [selectedShortcut, setSelectedShortcut] = useAtom(selectedShortcutAtom);
  const refreshTimerRef = useRef();

  useEffect(() => {
    return () => {
      clearTimeout(refreshTimerRef?.current);
    };
  }, []);

  const handleChangeStatFilters = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (!value) value = "";
    setSelectedShortcut("");
    const newFilters = { ...statFilters, [name]: value };
    setStatFilters(newFilters);
    const date = DateTime.fromISO(value);
    if (date.isValid && date.year >= 1000) {
      clearTimeout(refreshTimerRef?.current);
      refreshTimerRef.current = setTimeout(() => refreshWithFilters(newFilters), 500);
    }
  };

  const updateFiltersLast30Days = () => {
    const newFilters = {
      ...statFilters,
      beginAt: DateTime.local().minus({ days: 30 }).toISO(),
      endAt: DateTime.local().toISO(),
    };
    setSelectedShortcut("1");
    refreshWithFilters(newFilters);
    setStatFilters(newFilters);
  };
  const updateFiltersLast3Months = () => {
    const newFilters = {
      ...statFilters,
      beginAt: DateTime.local().minus({ months: 3 }).toISO(),
      endAt: DateTime.local().toISO(),
    };
    setSelectedShortcut("2");
    refreshWithFilters(newFilters);
    setStatFilters(newFilters);
  };
  const updateFiltersForever = () => {
    const newFilters = {
      ...statFilters,
      beginAt: "",
      endAt: "",
    };
    setSelectedShortcut("3");
    refreshWithFilters(newFilters);
    setStatFilters(newFilters);
  };

  return {
    statFilters,
    selectedShortcut,
    actions: {
      handleChangeStatFilters,
      updateFiltersLast30Days,
      updateFiltersLast3Months,
      updateFiltersForever,
    },
  };
};

export default useStatFilters;
